

























import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component({
    components: {},
})
export default class DetailedView extends Vue {
    name = 'DetailedView'
    @Prop() label? : string;
    @Getter overview_simplify !: boolean;

    getTitle(){
        if(this.label == undefined) {
            if(this.overview_simplify){
                return ""
            }
            return "Detailed View"
        } else {
            return this.label;
        }
    }
}
